<template>
<div class="kt-header__topbar-item kt-header__topbar-item--user">
    <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="10px,0px">
        <span class="kt-header__topbar-welcome kt-visible-desktop">{{ $t('hi') }},</span>
        <span class="kt-header__topbar-username kt-visible-desktop">
            <span v-if="current_user.user_type == user_types.REAL" v-text="current_user.first_name"></span>
            <span v-else-if="current_user.user_type == user_types.LEGAL" v-text="current_user.com_name_fa"></span>
        </span>
            <img v-if="current_user.avatar" alt="avatar_alt" v-bind:src="current_user.avatar" />
            <span v-else class="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">
                <i class="fa fa-user"></i>
            </span>
    </div>
    <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-xl">
        <!--begin: Head -->
        

        <!--end: Head -->

        <!--begin: Navigation -->
        <div class="kt-notification">
            <router-link to="/profile" class="kt-notification__item">
                <div class="kt-notification__item-icon">
                    <i class="flaticon2-calendar-3 kt-font-success"></i>
                </div>
                <div class="kt-notification__item-details">
                    <div class="kt-notification__item-title kt-font-bold">
                        {{ $t('my_profile') }}
                    </div>
                    <div class="kt-notification__item-time">
                        {{ $t('profile_setting') }}
                    </div>
                </div>
            </router-link>
            <div class="kt-notification__custom kt-space-between">
                <router-link to="/logout" class="btn btn-label btn-label-brand btn-sm btn-bold">
                    {{ $t('sign_out') }}
                </router-link>
            </div>
        </div>

        <!--end: Navigation -->
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { userTypes } from '@/constants/userTypes';

export default {
    data() {
        return {
            user_types: userTypes,
        }
    },
    computed: {
        ...mapGetters('user', [
            'current_user'
        ])
    },
    methods: {
        getFirstChar (str) {
            return str.substr(0, 1)
        }
    }
}
</script>

<style>

</style>